import axios from 'axios';
import {apiServerHost} from '../../common/APIServerSettings';

const getRedirectedRequest = (callBackFunc, redirectedRequestID) => {
  const params = new URLSearchParams();
  params.append("requestID", redirectedRequestID);

  axios.get(apiServerHost + "/manage/topic/builder/get/request", {
    params : params,
  })
  .catch( error => {
    
  })
  .then( response => {
    callBackFunc(response);
  });
}

export {getRedirectedRequest};